"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrideCheck = exports.getDefaultViewFdc3VersionFromAppInfo = void 0;
const InteropBroker_1 = require("../InteropBroker");
function getDefaultViewFdc3VersionFromAppInfo({ manifest, initialOptions }) {
    var _a, _b, _c, _d;
    const setVersion = (_c = (_b = (_a = manifest.platform) === null || _a === void 0 ? void 0 : _a.defaultViewOptions) === null || _b === void 0 ? void 0 : _b.fdc3InteropApi) !== null && _c !== void 0 ? _c : (_d = initialOptions.defaultViewOptions) === null || _d === void 0 ? void 0 : _d.fdc3InteropApi;
    return ['1.2', '2.0'].includes(setVersion !== null && setVersion !== void 0 ? setVersion : '') ? setVersion : undefined;
}
exports.getDefaultViewFdc3VersionFromAppInfo = getDefaultViewFdc3VersionFromAppInfo;
// TODO: Unit test this
function overrideCheck(overriddenBroker, fdc3InteropApi) {
    if (fdc3InteropApi && fdc3InteropApi === '2.0') {
        const mustOverrideAPIs = [
            'fdc3HandleFindInstances',
            'handleInfoForIntent',
            'handleInfoForIntentsByContext',
            'fdc3HandleGetAppMetadata',
            'fdc3HandleGetInfo',
            'fdc3HandleOpen',
            'handleFiredIntent',
            'handleFiredIntentForContext'
        ];
        const notOverridden = mustOverrideAPIs.filter((api) => {
            return overriddenBroker[api] === InteropBroker_1.InteropBroker.prototype[api];
        });
        if (notOverridden.length > 0) {
            console.warn(`WARNING: FDC3 2.0 has been set as a default option for Views in this Platform, but the required InteropBroker APIs for FDC3 2.0 compliance have not all been overridden.\nThe following APIs need to be overridden:\n${notOverridden.join('\n')}`);
        }
    }
}
exports.overrideCheck = overrideCheck;
